import React from 'react';

const Jonathan = () => {
  <h3>Jonathan</h3>;
};

export default Jonathan;
